import { useMutation, useQueryClient } from '@tanstack/react-query';
import { editRecentlyViewedDevices, editRecentlyViewedOrgs } from 'src/utils/api';
import { QUERY_KEY_MAP } from 'src/constants';
import { useGetRecentlyViewedDevices, useGetRecentlyViewedOrgs } from '../use-get-recently-viewed-devices';

export const useEditRecentlyViewedDevices = () => {
  const queryClient = useQueryClient();
  const { data } = useGetRecentlyViewedDevices();

  const { mutateAsync, isPending, isError, error } = useMutation({
    mutationKey: [QUERY_KEY_MAP.useEditRecentlyViewedDevices],
    mutationFn: editRecentlyViewedDevices,
  });

  const editRecentlyViewedDevicesAsync = async (deviceId: string) => {
    try {
      if (!Array.isArray(data) || typeof deviceId !== 'string') {
        return;
      }

      // max 4 items
      const param = [...new Set([deviceId, ...(data || [])])].slice(0, 4);

      await mutateAsync(param);
      await queryClient.invalidateQueries({
        queryKey: [QUERY_KEY_MAP.useGetRecentlyViewedDevices],
      });
    } catch (e) {
      console.error(e);
    }
  };

  return {
    editRecentlyViewedDevicesAsync,
    isLoading: isPending,
    isError,
    error,
  };
};

export const useEditRecentlyViewedOrgs = () => {
  const queryClient = useQueryClient();
  const { data } = useGetRecentlyViewedOrgs();

  const { mutateAsync, isPending, isError, error } = useMutation({
    mutationKey: [QUERY_KEY_MAP.useGetRecentlyViewedOrgs],
    mutationFn: editRecentlyViewedOrgs,
  });

  const editRecentlyViewedOrgAsync = async (orgId: string) => {
    try {
      if (!Array.isArray(data) || typeof orgId !== 'string') {
        return;
      }

      // max 5 items
      const param = [...new Set([orgId, ...(data || [])])].slice(0, 5);

      await mutateAsync(param);
      await queryClient.invalidateQueries({
        queryKey: [QUERY_KEY_MAP.useGetRecentlyViewedOrgs],
      });
    } catch (e) {
      console.error(e);
    }
  };

  return {
    editRecentlyViewedOrgAsync,
    isLoading: isPending,
    isError,
    error,
  };
};
